import { Link } from "react-router-dom";
import classes from "./CartList.module.css";
import Remove from "./Remove";
import { useNavigate } from "react-router-dom";
import { ButtonPrimary } from "../Button/Button";
import { useEffect, useState } from "react";

const CartList = ({ cart, inquireHandler, toggle }) => {
  let content;
  const navigate = useNavigate();
  const [hasItems, setHasItems] = useState(false);

  useEffect(() => {
    console.log(cart);
    if (cart.length > 0) {
      setHasItems(true);
    } else {
      setHasItems(false);
    }
  }, [cart]);

  if (hasItems) {
    content = cart.map((item) => {
      return (
        <li className={classes.cart__list} key={item.id}>
          <img
            src={item.img}
            alt="TBD"
            onClick={() => {
              navigate(`/product/${item.id}`, { replace: true });
              toggle();
            }}
          />

          <div className={classes.cart__item}>
            <span
              className={classes.itemName}
              onClick={() => {
                navigate(`/product/${item.id}`, { replace: true });
                toggle();
              }}
            >
              {item.itemName}
            </span>

            <Remove
              id={item.id}
              className={classes.remove}
              setHasItems={setHasItems}
            />
          </div>
        </li>
      );
    });
  }

  return (
    <div className={classes.cartListWrapper}>
      {!hasItems && (
        <p className={classes.hasNoItems}>你還沒有選擇任何商品喔✌️</p>
      )}
      <ul className={classes.cart}>{content}</ul>
      {hasItems && (
        <ButtonPrimary
          text="立即詢問"
          onClick={inquireHandler}
          className={classes.inquire}
        />
      )}
    </div>
  );
};

export default CartList;
